import React from 'react';
import ButtonWithIcon from '../buttonWithIcon';
import { ButtonsHolder } from './style';

export default function DefaultActionButtons({
  onCancel,
  onSubmit,
  isValid,
  backButtonIcon,
  nextButtonIcon,
  backButtonStyle,
  nextButtonStyle,
  ...otherProps
}) {
  return (
    <ButtonsHolder {...otherProps}>
      {
        onCancel ? (
          <ButtonWithIcon
            icon={backButtonIcon}
            {...backButtonStyle}
            onClick={() => onCancel()}
          />
        ) : (<div />)
      }
      <ButtonWithIcon
        icon={nextButtonIcon}
        {...nextButtonStyle}
        disabled={!isValid}
        onClick={() => onSubmit()}
      />
    </ButtonsHolder>
  );
}

DefaultActionButtons.defaultProps = {
  backButtonStyle: {},
  nextButtonStyle: {},
  backButtonIcon: 'arrowLeft',
  nextButtonIcon: 'arrowRight',
};

export { ButtonsHolder } from './style';
